import React, { Component } from 'react'
import { Container } from 'react-bootstrap'

import { TABLE_REPORTE_ESTADO_POR_CEREAL_TRIGO,
  TABLE_REPORTE_ESTADO_POR_CEREAL_SOJA,
  TABLE_REPORTE_ESTADO_POR_CEREAL_MAIZ,
  TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADAFO,
  TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADACE,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETGC,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELESOJA,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETSC,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCG,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCS,
  TABLE_REPORTE_ESTADO_POR_CEREAL_HARISOJA,
  TABLE_REPORTE_ESTADO_POR_CEREAL_BARRIDO,
  TABLE_TOTAL_ESTADO_POR_CEREAL
  // TABLE_TOTAL_ESTADO_POR_CEREAL_TRIGO,
  // TABLE_TOTAL_ESTADO_POR_CEREAL_SOJA,
  // TABLE_TOTAL_ESTADO_POR_CEREAL_MAIZ,
  // TABLE_TOTAL_ESTADO_POR_CEREAL_CEBADAFO,
  // TABLE_TOTAL_ESTADO_POR_CEREAL_CEBADACE,
  // TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETGC,
  // TABLE_TOTAL_ESTADO_POR_CEREAL_PELESOJA,
  // TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETSC,
  // TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETCG,
  // TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETCS
} from '../../../config/tables'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'
import './ReportePorCerealView.scss'

class ReportePorCerealView extends Component {
  render () {
    return (
      <Container fluid>
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL} />
        {/* <br />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_TRIGO} />
        <br />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_SOJA} />
        <br />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_MAIZ} />
        <br />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_CEBADAFO} />
        <br />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_CEBADACE} />
        <br />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETGC} />
        <br />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_PELESOJA} />
        <br />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETSC} />
        <br />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETCG} />
        <br />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETCS} /> */}
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_TRIGO} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_SOJA} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_MAIZ} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADAFO} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADACE} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETGC} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_PELESOJA} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETSC} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCG} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCS} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_HARISOJA} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_BARRIDO} />
      </Container>
    )
  }
}
export default ReportePorCerealView
